import { gql } from '@apollo/client'

export default gql`
  fragment modelInfo on Model {
    id
    name
  }
`
